import { Car } from "lucide-react";
import SeoLanding from "@/components/site/SeoLanding";

export default function PermisBoiteAuto() {
  return (
    <SeoLanding
      testId="page-boite-auto"
      seo={{
        title: "Permis boîte automatique Boulogne-Billancourt · 899 € | DDSBillancourt",
        description: "Passez votre permis B en boîte automatique à Boulogne-Billancourt : 13 leçons + 5 offertes à 899 €. Apprentissage plus rapide et plus serein, idéal pour conduire à Paris. Passerelle vers la boîte manuelle possible. Conduite 7j/7 de 7h à 22h.",
        path: "/permis-boite-automatique",
      }}
      breadcrumbName="Permis boîte automatique"
      badge="Permis B · Boîte automatique"
      badgeIcon={Car}
      h1="Permis boîte automatique à Boulogne-Billancourt"
      intro={[
        "Le permis boîte automatique (permis BEA) est la façon la plus rapide et la plus sereine d'obtenir votre permis de conduire. Sans embrayage ni passage de vitesses, vous vous concentrez sur l'essentiel : la circulation, les intersections et les autres usagers.",
        "Chez DDSBillancourt, votre auto-école à Boulogne-Billancourt (92100), la formation boîte automatique se fait sur des véhicules récents, avec un moniteur référent et un simulateur de conduite nouvelle génération — une première en Île-de-France.",
      ]}
      formules={[
        {
          name: "13 leçons + 5 offertes (boîte auto)",
          price: "899 €",
          priceNum: 899,
          highlight: true,
          features: ["13 leçons de conduite + 5 offertes", "Livret d'apprentissage", "Simulateur de conduite", "Paiement en plusieurs fois"],
        },
        {
          name: "Pack 5 leçons à la carte",
          price: "325 €",
          priceNum: 325,
          features: ["5 leçons de 55 minutes", "Idéal en complément ou après échec", "Paiement flexible"],
        },
      ]}
      sections={[
        {
          title: "Pourquoi choisir la boîte automatique ?",
          paragraphs: [
            "À Boulogne-Billancourt comme dans tout l'ouest parisien, la circulation est dense : embouteillages, démarrages en côte, ronds-points. La boîte automatique supprime la gestion de l'embrayage et rend l'apprentissage nettement plus rapide.",
          ],
          bullets: [
            { title: "Formation plus courte", text: "13 heures de formation minimum (contre 20 heures en boîte manuelle) : vous êtes présentable à l'examen plus tôt." },
            { title: "Moins de stress le jour J", text: "pas de calage, pas de mauvaise vitesse : nos élèves abordent l'examen avec plus de confiance." },
            { title: "Adaptée à la conduite urbaine", text: "idéale pour circuler à Paris, Porte de Saint-Cloud, Porte d'Auteuil ou Place d'Italie — nos 4 zones de conduite." },
            { title: "L'avenir de l'automobile", text: "toutes les voitures électriques et hybrides sont automatiques : ce permis correspond au parc de demain." },
          ],
        },
        {
          title: "Comment se déroule la formation ?",
          paragraphs: [
            "Après une heure d'évaluation, votre moniteur construit un parcours personnalisé. Vous alternez leçons sur route (55 minutes de conduite + 5 minutes de bilan), séances sur simulateur pour les situations complexes, et cours de code illimités sur notre plateforme e-learning de 36 cours avec quiz interactifs.",
            "Les leçons sont disponibles 7 jours sur 7, de 7h à 22h du lundi au samedi et de 10h à 20h le dimanche — parfait si vous travaillez ou étudiez en semaine.",
          ],
        },
        {
          title: "Et si je veux conduire une boîte manuelle plus tard ?",
          paragraphs: [
            "C'est prévu : 3 mois après l'obtention de votre permis boîte automatique, une simple formation passerelle de 7 heures (sans repasser l'examen) vous permet de conduire une boîte manuelle. Nous proposons cette passerelle directement à l'agence, sur devis.",
          ],
        },
      ]}
      faq={[
        { q: "Combien de temps faut-il pour obtenir le permis boîte automatique ?", a: "Le minimum légal est de 13 heures de formation. En intensif, nos élèves peuvent être présentés à l'examen en quelques semaines. Découvrez aussi nos formations accélérées 13h, 20h et 30h." },
        { q: "Le permis boîte automatique est-il moins cher ?", a: "Oui : notre formule 13 leçons + 5 offertes est à 899 €, contre 999 € pour la formule boîte manuelle — et il faut en moyenne moins d'heures pour atteindre le niveau de l'examen." },
        { q: "Puis-je conduire une voiture manuelle avec un permis boîte auto ?", a: "Pas directement, mais après 3 mois vous pouvez suivre la formation passerelle de 7 heures (sans examen) pour lever la restriction. Nous la proposons à l'agence." },
        { q: "Où se déroulent les leçons de conduite ?", a: "Au départ de Boulogne-Billancourt (siège), Porte de Saint-Cloud (16ᵉ), Porte d'Auteuil (16ᵉ) ou Place d'Italie (13ᵉ). Vous choisissez votre point de rendez-vous à la réservation." },
      ]}
      crossLinks={[
        { to: "/permis-boite-manuelle", label: "Permis boîte manuelle" },
        { to: "/conduite-accompagnee", label: "Conduite accompagnée (AAC)" },
        { to: "/accelere", label: "Formations accélérées" },
        { to: "/code-de-la-route", label: "Code de la route" },
        { to: "/moto", label: "Permis moto" },
      ]}
    />
  );
}
